'use client';

import classes from './CardsCarousel.module.scss';
import { Carousel } from '@mantine/carousel';
import { Button, Container, Paper, Space, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

import '@mantine/carousel/styles.css';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { useDictionary } from '@/src/dictionaries/dictionary-provider';
import { fetchProducts } from '@/src/helpers/fetch-products';
import { Locale, Product } from '@/src/types/Header';
import { Title } from '../../Title/Title';

interface LocalizedText {
  en: string;
  fr: string;
}

interface CardData {
  url?: string;
  mainImage?: string;
  price?: number;
  description?: LocalizedText;
  image: string;
  title: LocalizedText;
  category: string;
  typeContent?: 'products' | 'articles';
}

interface CardProps {
  title: string;
  cardData: CardData[];
}

function Card({ cardData }: { cardData: CardData }) {
  const dictionary = useDictionary();
  const params = useParams();
  const lang = (params.lang as Locale) ?? 'en';

  return (
    <Paper
      shadow="md"
      p="xl"
      style={{ backgroundImage: `url(${cardData?.image ?? cardData?.mainImage})` }}
      className={classes.card}
    >
      <div className={classes.content}>
        {/* @ts-ignore */}
        <h2>{cardData.title[lang] ? cardData.title[lang] : cardData.title}</h2>
        {/* @ts-ignore */}
        {/* <p>{cardData.description[lang] ? cardData.description[lang] : cardData.description}</p> */}

        <div className={`${classes.section} ${classes.bottomCard}`}>
          {/* @ts-ignore */}
          {/* {cardData?.price && (
                        <div>
                            <Text fz="xl" fw={700} style={{ lineHeight: 1 }}>
                                {cardData?.price} {dictionary.products.priceLabel}
                            </Text>
                        </div>
                    )} */}
          <Space h="lg" />

          <Button
            color="white"
            variant="outline"
            fullWidth={!cardData?.price}
            style={{ flex: 1 }}
            className={classes.button}
          >
            {cardData?.price ? dictionary.products.readMore : dictionary.articles.readMore}
          </Button>
        </div>
      </div>
    </Paper>
  );
}

export function CardsCarousel({ data }: { data: CardProps }) {
  const theme = useMantineTheme();
  const mobile = useMediaQuery(`(max-width: 48em)`);
  const [dataToDisplay, setDataToDisplay] = useState<Product[] | CardData[]>([]);
  const params = useParams();
  const lang = (params.lang as string) ?? 'en';

  useEffect(() => {
    const fetchData = async () => {
      const result: any = await getDataFromCardData(data.cardData);
      setDataToDisplay(result.products);
    };
    fetchData();
  }, []);

  if (!dataToDisplay || dataToDisplay?.length === 0) {
    return null;
  }

  const slides = dataToDisplay.map((item) => {
    // @ts-ignore
    const titleToDisplay = item.title[lang]
      // @ts-ignore
      ? item?.title[lang]?.replaceAll(' ', '-')
      // @ts-ignore
      : item?.title?.replaceAll(' ', '-');

    return (
      <Carousel.Slide key={titleToDisplay}>
        <Link
          // @ts-ignore
          href={`/${data.cardData ? `${data.cardData}/` : ''}${item.url ?? titleToDisplay}`}
          className={classes.link}
        >
          {/* @ts-ignore */}
          <Card cardData={item} />
        </Link>
      </Carousel.Slide>
    );
  });

  return (
    <section className={classes.section}>
      <Container>
        <Title title={data.title} />
        <Carousel
          slideSize={{ base: '100%', sm: '50%' }}
          slideGap={{ base: 'xl', sm: 2 }}
          align="start"
          slidesToScroll={1}
          previousControlProps={{
            'aria-label': 'Previous slide',
          }}
          nextControlProps={{
            'aria-label': 'Next slide',
          }}
        >
          {slides}
        </Carousel>
      </Container>
    </section>
  );
}

const getDataFromCardData = async (cardData: CardData[] | 'products' | 'articles') => {
  if (cardData === 'products') {
    const fetchedProducts = await fetchProducts(1, '');

    return fetchedProducts;
  }
};
